import * as React from 'react';

const SvgArrowSelect = (props) => React.createElement(
  "svg",
  Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props),
  React.createElement("path", { fill: "#88827E", d: "m20 11 2 2h-7.59l8.3 8.29-1.42 1.42-8.29-8.3V22l-2-2v-9h9ZM4 20h1v2H2v-3h2v1ZM9 22H7v-2h2v2ZM4 17H2v-4h2v4ZM4 11H2V7h2v4ZM22 9h-2V7h2v2ZM5 4H4v1H2V2h3v2ZM22 5h-2V4h-1V2h3v3ZM11 4H7V2h4v2ZM17 4h-4V2h4v2Z" })
);

export { SvgArrowSelect as default };
//# sourceMappingURL=ArrowSelect.es.js.map
